import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import {
  getModelIsPendingSel,
  modelIDSel,
  diagramsSel,
  diagramsProductsSel,
  modelActions,
  modelNumberSel,
  textFilterSel,
  activeDiagramSel,
  activePartSel,
  featuredProductsSel,
  commonPartsSel
} from 'src/store/modules/model';
import { showOnlyMsrpSel } from 'src/store/modules/msrp';
import { isLoggedInSel } from 'src/store/modules/signin';
import { activeAccountSel } from 'src/store/modules/signin';
import { cartActions } from 'src/store/modules/cart';
import { userActions } from 'src/store/modules/user';

import ModelView from './ModelView';
import ProductModel from 'src/model/product.model';

import { analyticsActions } from 'src/analytics/store';

const mapStateToProps = (state: any) => {
  return {
    getModelIsPending: getModelIsPendingSel(state),
    modelID: modelIDSel(state),
    diagrams: diagramsSel(state),
    modelNumber: modelNumberSel(state),
    allProducts: diagramsProductsSel(state),
    activeAccount: activeAccountSel(state),
    textFilter: textFilterSel(state),
    activeDiagram: activeDiagramSel(state),
    isLoggedIn: isLoggedInSel(state),
    activePart: activePartSel(state),
    onlyMSRP: showOnlyMsrpSel(state),
    featuredProducts: featuredProductsSel(state),
    commonParts: commonPartsSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getModelData: (
    modelId: string,
    activeAccount: string,
    manufacturer: string
  ) => dispatch(modelActions.getModel(modelId, activeAccount, manufacturer)),
  setTextFilter: (searchTerm: string) =>
    dispatch(modelActions.setTextFilter(searchTerm)),
  setActiveDiagram: (diagramId: number) => {
    dispatch(modelActions.setActiveDiagram(diagramId));
  },
  updateDiagramProduct: (
    productId: string,
    manufacturerCode: string,
    ownerDiagram: number
  ) =>
    dispatch(
      modelActions.updateDiagramProduct(
        productId,
        manufacturerCode,
        ownerDiagram
      )
    ),
  setActivePart: (part: ProductModel | null) =>
    dispatch(modelActions.getActivePart(part)),
  toggleFavoritePart: (
    name: string,
    mfc: string,
    ownerDiagram: number,
    favorite: boolean,
    favoriteId: number,
    featured: boolean
  ) =>
    dispatch(
      modelActions.toggleFavorites(
        name,
        mfc,
        ownerDiagram,
        favorite,
        favoriteId,
        featured
      )
    ),
  updateFeaturedProduct: (productId: string, manufacturerCode: string) =>
    dispatch(modelActions.updateFeaturedProduct(productId, manufacturerCode)),
  updateDiagramProducts: (
    products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }>
  ) => dispatch(modelActions.updateDiagramProducts(products)),
  updateCommonParts: (
    products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }>
  ) => dispatch(modelActions.updateCommonProducts(products)),
  getCartBasicInfo: () => dispatch(cartActions.getBasicInfo()),
  getUserDetails: () => dispatch(userActions.getUserDetails()),
  sendModelDiagramProductImpression: data =>
    dispatch(analyticsActions.sendModelDiagramProductImpression(data)),
  modelDiagramProductClick: data =>
    dispatch(analyticsActions.modelDiagramProductClick(data))
});

export const pureComponent = ModelView;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(ModelView as any)));

interface IDispatchFromProps {
  getModelData(
    modelId: string,
    activeAccount: string,
    manufacturer: string
  ): any;
  setTextFilter(searchTerm: string): any;
  setActiveDiagram(diagramId: number): any;
  updateDiagramProduct(
    productId: string,
    manufacturerCode: string,
    ownerDiagram: number
  ): any;
  setActivePart(part: ProductModel | null): void;
  toggleFavoritePart(
    name: string,
    mfc: string,
    ownerDiagram: number,
    favorite: boolean,
    favoriteId: number,
    featured: boolean
  ): void;
  updateFeaturedProduct(productId: string, manufacturerCode: string): any;
  updateDiagramProducts(
    products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }>
  ): any;
  updateCommonParts(
    products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }>
  ): any;
  getCartBasicInfo: () => void;
  getUserDetails: () => void;
  sendModelDiagramProductImpression(data: any): any;
  modelDiagramProductClick(data: any): any;
}
